import {
  Table as ChakraTable,
  TableCellProps as ChakraTableCellProps,
  TableColumnHeaderProps as ChakraTableColumnHeaderProps,
  TableRootProps as ChakraTableRootProps,
  TableScrollAreaProps as ChakraTableScrollAreaProps,
} from '@chakra-ui/react'

import { Box } from './box'

export type TableRootProps = ChakraTableRootProps

export const TableScrollArea = ({
  children,
  ...props
}: ChakraTableScrollAreaProps) => {
  return (
    <Box boxSize="full" p="3" borderRadius="lg" borderWidth="1px">
      <ChakraTable.ScrollArea h="full" {...props}>
        {children}
      </ChakraTable.ScrollArea>
    </Box>
  )
}
export const TableRoot = ({ ...props }: ChakraTableRootProps) => {
  return <ChakraTable.Root stickyHeader {...props} />
}
export const TableHeader = ChakraTable.Header
export const TableRow = ChakraTable.Row
export const TableColumnHeader = ({
  ...props
}: ChakraTableColumnHeaderProps) => {
  return (
    <ChakraTable.ColumnHeader
      px="6"
      py="2.5"
      color="gray.600"
      fontSize="sm"
      {...props}
    />
  )
}
export const TableBody = ChakraTable.Body
export const TableCell = ({ ...props }: ChakraTableCellProps) => {
  return <ChakraTable.Cell px="6" py="2.5" fontSize="md" {...props} />
}
export const TableFooter = ChakraTable.Footer
export const TableColumn = ChakraTable.Column
